// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonNavigation_wrapper__3Euag","firstButton":"ButtonNavigation_firstButton__48vtN"};